<!DOCTYPE html>
<html class="ui-g" lang="en">
  <head>
    <title>{{ title }}</title>
  </head>
<!-- HEADER -->
<div class="ui-g-12" id="header">
  <div class=" app-branding center-header alignBaseline">

    <div class="ui-grid-col-2 tableDisplay">
      <a (click)="logoClick()"><img id="logo" alt="Ford Oval" src="../assets/image/Ford-Logo.png"/></a>
    </div>

    <!-- Title Area    -->
    <div class="app-branding ui-grid-col-6 alignBaseline noMarginRight">
      <h1 class="title">{{ title }} </h1>
    </div>

    <!-- Welcome and User Name -->
    <div class="ui-grid-col-3 alignBaseline floatRight">
      <h3 [attr.aria-label]="'Welcome, ' + (userID || 'Guest')">
          <span [hidden]=hiddenIndicator id="span">Welcome, {{ userID }}</span>
      </h3>
    </div>

  </div>
</div>

<!-- CENTER DIV -->
<div class="ui-g-12" class="center-div-app" id="content">
  <!--  Side bar component    -->
  <app-side-bar></app-side-bar>
</div>

<div class="ui-g-12" id="divenblanco"></div>

</html>

<!-- FOOTER -->
<div class="ui-g-12 text-center center-footer" id="app-footer">
  <p> {{year}}  Ford Motor Company</p>
</div>
